export default __webpack_public_path__ + "static/media/high_pool1.9372bb1a.jpg";